import { render, staticRenderFns } from "./lab-catalog-slider.vue?vue&type=template&id=11adaa4f&"
import script from "./lab-catalog-slider.vue?vue&type=script&lang=js&"
export * from "./lab-catalog-slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\OSPanel\\domains\\specialty.local\\local\\js\\specialty\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11adaa4f')) {
      api.createRecord('11adaa4f', component.options)
    } else {
      api.reload('11adaa4f', component.options)
    }
    module.hot.accept("./lab-catalog-slider.vue?vue&type=template&id=11adaa4f&", function () {
      api.rerender('11adaa4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/market/lab-catalog-slider.vue"
export default component.exports